<template>
	<div>
		<div class="d-flex align-items-center justify-content-between">
          <h1 class="h3 mb-3 text-gray-800">
            {{ $t("Notificações") }}
          </h1>
          <b-button-group v-if="!loading">
            <b-button variant="outline-dark" :class="viewFilterReport === true ? 'active' : ''" @click="viewFilters">
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
          </b-button-group>
        </div>
		
		<load v-if="loading" />

		<b-card v-else class="shadow">
			<div class="col-12" v-if="viewFilterReport">
			  <form @submit.prevent="getDados" ref="formFiltros">
				<div class="row">
				  <div class="col-md-8">
					<label><b>Pesquisar</b></label>
					<div class="input-group">
					  <b-input placeholder="Pesquisar por: Título"
						class="form-control search-input" type="text" v-model="search" aria-describedby="input-search"
						@keydown.enter.prevent="getDados" />
					  <div class="input-group-append" role="button" @click.prevent="getDados">
						<span class="input-group-text" id="input-search"><i class="fas fa-search search-icon" /></span>
					  </div>
					</div>
					<p class="small text-muted">
					  No campo acima você pode pesquisar por: Título
					</p>
				  </div>
				</div>

				<div class="row pt-2 mb-4 px-0 d-flex justify-content-end">
				  <div class="col-auto px-2 text-right">
					<button class="btn btn-default btn-sm" @click.prevent="viewFilterReport = false">
					  <i class="fas fa-times"></i>
					</button>
	
					<button type="button" class="btn btn-secondary btn-sm" @click.prevent="limparFiltros()">
					  {{ $t("Limpar Filtros") }}
					</button>
					<button class="btn btn-success btn-submit btn-sm" data-style="zoom-in" type="submit">
					  <i class="fas fa-chart-bar"></i>
					  {{ $t("Filtrar") }}
					</button>
				  </div>
				</div>

			  </form>
			</div>

			<div class="row">
				<a
					class="btn btn-sm bg-light d-flex align-items-center ml-3"
					href="#"
					@click.prevent="markAllAsRead"
				>
					<i class="mdi mdi-bell-remove mdi-18px mr-2 text-danger"></i>
					<b> Marcar todos como lido</b>
				</a>
				<div class="col-12">
					<b-card class="mb-3" no-body>
						<!-- <loading-animation
                            :active.sync="loading"
                            :is-full-page="false"
                            :opacity="1"
                            color="#5895FF"
                        /> -->
						<b-table
							:fields="[
								{
									key: 'titulo',
									label: 'Notificação',
								},
								{
									key: 'action',
									label: '',
								},
							]"
							:items="notificiationsList"
							:responsive="true"
							striped
							stacked="md"
							hover
							show-empty
							small
							outlined
							table-class="mb-0"
						>
							<template v-slot:cell(titulo)="data">
								<small class="m-0">
									NOTIFICAÇÃO ENVIADA POR:
									<span class="badge badge-default mx-2">
										<b>{{ data.item.data.remetente ?? "SISTEMA" }}</b>
									</span>
									{{ data.item.created_at | moment("DD/MM/YYYY h:mm") }}
								</small>
								<br />
								<span v-if="data.item.data.link">
									<router-link :to="data.item.data.link">
										<span v-html="data.item.data.titulo"></span>
									</router-link>
								</span>
								<span v-else v-html="data.item.data.titulo"></span>
								<p v-if="data.item.read_at != null">
									<small class="text-success" title="Visualizado">
										<i class="mdi mdi-check-all"></i>
										{{ data.item.read_at | moment("DD/MM/YYYY h:mm") }}
									</small>
								</p>
								<!-- <p v-else>
									<a href="#" @click="markAsRead(data.item.id)" class="text-info"
										><i class="fas fa-check"></i>
										Marcar como lido
									</a>
								</p> -->
							</template>

							<template v-slot:cell(action)="data">
								<div class="d-flex justify-content-end">
									<a
										v-if="data.item.read_at == null"
										@click="markAsRead(data.item.id)"
										title="Marcar como lido"
										class="btn btn-success btn-sm mb-0"
									>
										<i class="mdi mdi-check"></i>
									</a>
									<router-link
										:to="data.item.data.link"
										title="Abrir "
										class="btn btn-primary btn-sm mb-0"
									>
										<i class="mdi mdi-open-in-new"></i>
									</router-link>
									<router-link
										v-if="data.item.data.edit_link"
										:to="data.item.data.edit_link"
										title="Editar"
										class="btn btn-success btn-sm mb-0"
									>
										<i class="mdi mdi-square-edit-outline"></i>  
									</router-link>
								</div>
							</template>
							<template v-slot:empty="scope">
								<div class="text-center my-5">
									<img
										:alt="$t('No results')"
										class="mb-5"
										src="/img/icons/robot.svg"
										style="max-height: 165px"
									/>
									<h3 class="bold">
										{{ $t("No records found") }}
									</h3>
								</div>
							</template>
							<!-- <template v-slot:emptyfiltered="scope">
								<div class="text-center my-5">
									<img
										:alt="$t('No results')"
										class="mb-5"
										src="/img/icons/robot.svg"
										style="max-height: 165px"
									/>
									<h3>
										{{ $t("No records match the entered search") }}
									</h3>
								</div>
							</template> -->
						</b-table>
					</b-card>
					<div class="row align-items-center">
						<div class="col-lg-6 col-md-12">
							<div class="form-group d-inline-flex mb-0">
								<select
									class="form-control"
									style="width: 70px"
									v-model="perPage"
									v-on:change="getDados"
								>
									<option value="5">5</option>
									<option value="10">10</option>
									<option value="25">25</option>
									<option value="50">50</option>
								</select>
							</div>
							<div class="d-inline-flex ml-2">
								<b-pagination
									:per-page="perPage"
									:total-rows="pagination.total"
									@change="changePage"
									v-model="page"
								/>
							</div>
						</div>
						<div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
							<div class="float-lg-right">
								{{ $t("Showing page") }}
								{{ pagination.currentPage }} {{ $t("of") }}
								{{ pagination.totalPages }}
								{{ $t("pages in") }} {{ pagination.total }}
								{{ $t("records") }}
							</div>
						</div>
					</div>
				</div>
				<router-view />
			</div>
		</b-card>
	</div>
</template>

<script>
export default {
	name: "Notifications",
	metaInfo() {
		return {
			title: this.$i18n.t("Notifications"),
		};
	},
	data() {
		return {
			page: 1,
			search: "",
			perPage: 10,
			loading: true,
			pagination: {
				currentPage: 0,
				perPage: 0,
				total: 0,
				totalPages: 0,
			},
			notificiationsList: [],
		};
	},
	mounted() {
		this.getDados();
	},
	methods: {
		limparFiltros() {
			this.search = "";
		},
		// Change the page
		changePage(page) {
			if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
				this.page = page;
				this.getDados();
				this.getNotifications();
			}
		},
		markAsRead(idNotification) {
			this.$store.dispatch("markAsRead", { id: idNotification });
			this.getDados();
		},
		markAllAsRead(context) {
			this.$store.dispatch("markAllAsRead");
			this.getDados();
		},
		// Get roles list
		getDados() {
			this.loading = true;
			axios
				.get("api/dashboard/admin/notifications", {
					params: {
						page: this.page,
						search: this.search,
						perPage: this.perPage,
					},
				})
				.then((response) => {
					this.notificiationsList = response.data.data;
					this.pagination = response.data.pagination;
					if (this.pagination.totalPages < this.pagination.currentPage) {
						this.page = this.pagination.totalPages;
						this.getDados();
					} else {
						this.loading = false;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
	},
};
</script>
